export default __webpack_public_path__ + "static/media/cam-rigth.934f4b8c.svg";